export const CODES_KEY = '_codes_api_path';

export const MISSING_LANG_LABEL_PREFIX = 'Missing:';

export const LANGUAGE_LEVELS = 'TYÖNHAKUPROFIILI_KIELITAIDON_TASO';
export const DRIVING_LICENSE_CLASSES = 'AJOKORTTILUOKKA';
export const PERMISSIONS_AND_LICENSES = 'TYÖNHAKUPROFIILI_LUPA_KORTTI';
export const EDUCATION_DEGREES = 'TYÖNHAKUPROFIILI_KOULUTUS';
export const EDUCATION_LEVELS = 'KOULUTUSASTE';
export const WORK_START = 'TYÖN_ALOITUS';
export const TEMPORARY_WORK_DURATION = 'MÄÄRÄAIKAISUUDEN_KESTO';
export const EURES_LANGUAGES = 'KIELI';
export const EURES_COUNTRIES = 'MAA';
export const EURES_EU_EFTA_COUNTRIES = 'MAA_EU_EFTA';
export const KIELI_50 = 'KIELI';
export const ISCO_GROUPS = 'isco';
export const EMPLOYMENT_RELATIONSHIPS = 'PALVELUSSUHDE';

export const COUNTRY = 'MAA';
export const MUNICIPALITY = 'KUNTA';
export const REGION = 'MAAKUNTA';
export const EVENT_CARD_EVENTDATETYPE = 'TAPAHTUMAKORTTI_TAPAHTUMAPÄIVÄTYYPPI';

export const INDUSTRY = 'TOIMIALA';
export const COMPANY_FORM = 'TYÖNHAKUPROFIILI_YRITYSMUOTO';

export enum KOPA_CODE {
  ORGANIZATION_TYPE = 'ORGANISAATIOMUOTO',
  MUNICIPALITY = 'KUNTA',
  COUNTRY = 'MAA',
  REGION = 'MAAKUNTA',
  EVENT_CARD_EVENTDATETYPE = 'TAPAHTUMAKORTTI_TAPAHTUMAPÄIVÄTYYPPI',
  INDUSTRY = 'TOIMIALA',
  COMPANY_FORM = 'TYÖNHAKUPROFIILI_YRITYSMUOTO',
  DRIVING_LICENSE_CLASSES = 'AJOKORTTILUOKKA',
  PERMISSIONS_AND_LICENSES = 'TYÖNHAKUPROFIILI_LUPA_KORTTI',
  EMPLOYMENT_START = 'TYÖN_ALOITUS',
  LANGUAGE_LEVELS = 'TYÖNHAKUPROFIILI_KIELITAIDON_TASO',
  LANGUAGE_SKILLS = 'ESCO_KIELITAITO',
  LANGUAGE = 'KIELI',
  WORKING_TIME = 'TYÖSKENTELYAIKA',
  OCCUPATION = 'ESCO_AMMATTI',
  SKILL = 'ESCO_OSAAMINEN',
  EMPLOYMENT_RELATIONSHIPS = 'PALVELUSSUHDE',
  EMPLOYMENT_CONTINUITY = 'TYÖN_JATKUVUUS',
  WORK_TIME = 'TYÖAIKA',
  WAGE_PRINCIPLE = 'PALKAN_PERUSTE',
  JOB_POSTING_STATUS = 'TYOPAIKKAILMOITUKSEN_TILA',
  PERSONNEL_SIZE_CLASS = 'HENKILOSTON_SUURUUSLUOKKA_HS2',
  EMPLOYER_SERVICE_NEED = 'TYONANTAJAN_PALVELUTARVE',
  CONTACT_PERSON_AREAS_OF_RESPONSIBILITY = 'YHTEYSHENKILON_VASTUUALUE',
  POST_OFFICE = 'POSTITOIMIPAIKKA',
  EMPLOYER_SERVICE_PROFILE = 'TYONANTAJAN_PALVELUPROFIILI',
  EMPLOYER_EVENT_TOPIC = 'TYONANTAJAN_TAPAHTUMA_AIHE',
  EMPLOYER_EVENT_CATEGORY = 'TYONANTAJAN_TAPAHTUMA_KATEGORIA',
  CONTACT_METHOD = 'YHTEYDENOTTO_YHTEYDENOTTOTAPA',
  HANDLING_STATE = 'KASITTELYN_TILA',
  PRESENTATION_RESULT = 'TYONVALITYS_TYONANTAJA_ESITTELYN_LOPPUTULOS',
  EDUCATION_DEGREES = 'TYÖNHAKUPROFIILI_KOULUTUS'
}
